module.exports = __webpack_public_path__ + "static/media/callCenterIcon.0966e587.png";